export default __webpack_public_path__ + "static/media/Error-404.cfef5da4.svg";